import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CoinHelperService {
  constructor() {}

  getYears(): number[] {
    const currentYear = new Date().getFullYear();
    const startYear = 1900;
    return Array.from(
      { length: currentYear - startYear + 1 },
      (_, index) => currentYear - index
    );
  }

  getMintOptions() {
    const allOptions = [
      'C -Charlotte',
      'CC – Carson City',
      'D – Dahlonega',
      'D – Denver',
      'O – New Orleans',
      'P – Philadelphia',
      'S – San Francisco',
      'W – West Point',
      'Colonial',
      'Post Colonial',
     
    ];
    return allOptions;
  }

  getCoinTypes() {
    const allOptions = [
      'Circulation Coins',
      'Commemorative Coins',
      'Bullion Coins',
      'Proof Coins',
      'Mint Sets',
      'Error Coins',
      'Ancient Coins',
      'Fantasy Coins',
      'Pattern Coins',
      'Territorial Coins',
      'Hobo Nickels',
    ];
    return allOptions;
  }

  getCoinDenomes() {
    const allOptions = [
      'United States Dollar (USD)',
      'Euro (EUR)',
      'British Pound Sterling (GBP)',
      'Japanese Yen (JPY)',
      'Canadian Dollar (CAD)',
      'Australian Dollar (AUD)',
      'Swiss Franc (CHF)',
    ];
    return allOptions;
  }

  getCoinProofs() {
    const allOptions = [
      'Uncirculated',
      'Circulated',
      'Proof',
      'Reverse Proof',
      'Burnished',
      'Satin',
      'Specimen'
     
    ];
    return allOptions;
  }

  getCoinVariety() {
    const allOptions = [
      'Die Variety',
      'Mint Mark Variety',
      'Error Variety',
      'Design Variety',
      'Composition Variety',
      'Pattern Variety',
      'Transitional Variety',
      'Overstrike Variety',
    ];
    return allOptions;
  }

  getCoinGrades() {
    const allOptions = [
      'PO',
      'FR',
      'AG',
      'G, G4',
      'G+, G6',
      'VG, VG8',
      'VG+, VG10',
      'F, F12',
      'F+, F15',
      'VF, VF20',
      'VF25',
      'Ch.VF, VF+, VF30',
      'Ch. VF, VF+, VF35',
      'Ex. Fine, EF40',
      'Ch. Ex. Fine, EF45',
      'AU, AU50',
      'Ch. AU, AU55',
      'Ch. AU, AU58',
      
    ];
    return allOptions;
  }


  getCoinGradeOption() {
    const allOptions = [
      {label:'PO', value:'1'},
      {label:'FR', value:'2'},
      {label:'AG', value:'3'},
      {label:'G, G4', value:'4'},
      {label:'G+, G6', value:'6'},
      {label:'VG, VG8', value:'8'},
      {label:'VG+, VG10', value:'10'},
      {label:'F, F12', value:'12'},
      {label:'F+, F15', value:'15'},
      {label:'VF, VF20', value:'20'},
      {label:'VF25', value:'25'},
      {label:'Ch.VF, VF+, VF30', value:'30'},
      {label:'Ch. VF, VF+, VF35', value:'35'},
      {label:'Ex. Fine, EF40', value:'40'},
      {label:'Ch. Ex. Fine, EF45', value:'45'},
      {label:'AU, AU50', value:'50'},
      {label:'AU53', value:'53'},
      {label:'Ch. AU, AU55', value:'55'},
      {label:'Ch. AU, AU58', value:'58'},
      {label:'MS60', value:'60'},
      {label:'MS61', value:'61'},
      {label:'MS62', value:'62'},
      {label:'MS63', value:'63'},
      {label:'MS64', value:'64'},
      {label:'MS65', value:'65'},
      {label:'MS66', value:'66'},
      {label:'MS67', value:'67'},
      {label:'MS68', value:'68'},
      {label:'MS69', value:'69'},
      {label:'MS70', value:'70'},


    ];

    const options = allOptions.sort( (a,b) => Number(b.value) - Number(a.value));
    return options;
  }


  gradeDefinitions = [
    { grade: '70', definition: 'A coin with no post-production imperfections at 5x magnification. AS STRUCK BY THE MINT.' },
    { grade: '69', definition: 'A fully struck coin with nearly imperceptible imperfections.' },
    { grade: '68', definition: 'Very sharply struck with only miniscule imperfections.' },
    { grade: '67', definition: 'Sharply struck with only a few imperfections.' },
    { grade: '66', definition: 'Very well struck with negligible marks and hairlines.' },
    { grade: '65', definition: 'Well struck with minimal marks or hairlines.' },
    { grade: '64', definition: 'Well struck with minor marks or hairlines and other miniscule imperfections.' },
    { grade: '63', definition: 'Slightly weak or average strike with minor abrasions and hairlines of varying sizes.' },
    { grade: '62', definition: 'Slightly weak or average strike with moderate abrasions and hairlines of varying sizes.' },
    { grade: '61', definition: 'Weak or average strike with no trace of wear. Heavy marks and/or abrasions.' },
    { grade: '60', definition: 'Weak or average strike with no trace of wear. Many heavy marks and abrasions. Dull luster.' },
    { grade: '58', definition: 'Slight wear on the highest points of the design. Full details.' },
    { grade: '55', definition: 'Slight wear on less than 50% of the design. Full details.' },
    { grade: '53', definition: 'Slight wear on more than 50% of the design. Full details except for very minor softness on the high points.' },
    { grade: '50', definition: 'Slight wear on more than 50% of the design. Full details except for minor softness on the high points.' },
    { grade: '45', definition: 'Complete details with minor wear on some of the high points.' },
    { grade: '40', definition: 'Complete details with minor wear on most of the high points.' },
    { grade: '35', definition: 'Complete details with wear on all of the high points.' },
    { grade: '30', definition: 'Nearly complete details with softness on the design areas.' },
    { grade: '25', definition: 'Nearly complete details with more softness than a VF30 on the design areas.' },
    { grade: '20', definition: 'Moderate design detail with sharp letters and digits.' },
    { grade: '15', definition: 'Recessed areas show slight softness. Letters and digits are sharp.' },
    { grade: '12', definition: 'Recessed areas show more softness than F15. Letters and digits are sharp.' },
    { grade: '10', definition: 'Wear throughout the design. Letters and digits show softness.' },
    { grade: '8', definition: 'Wear throughout the design. Letters and digits show more softness than a VG10.' },
    { grade: '6', definition: 'Peripheral letters and digits are full. Rims are sharp.' },
    { grade: '4', definition: 'Peripheral letters and digits are nearly full. Rims exhibit wear.' },
    { grade: '3', definition: 'Most letters and digits are readable. Rims are worn into the fields.' },
    { grade: '2', definition: 'Some details are visible. Rims are barely visible.' },
    { grade: '1', definition: 'Enough detail to identify the coin\'s date and type. Rims are flat or nearly flat.' }
  ];
  

  getSelectedGradeDefination(grade:string){
      const foundDefinition = this.gradeDefinitions.find(def => def.grade ===  grade);
      return foundDefinition ? foundDefinition.definition : '';
   
  }

}
